import { all, call, put, takeEvery } from 'redux-saga/effects';

import { fetchCsrfToken, getUserData, login, logout } from '../../services/api/auth';
import { createNavigateTo } from '../navigation/saga';
import { USER_ACTIONS, USER_TYPES } from './actions';

export function* watchUserActions() {
  yield all([
    takeEvery(USER_TYPES.LOGIN_REQUEST, loginUser),
    takeEvery(USER_TYPES.GET_DATA_REQUEST, getUserDetails),
    takeEvery(USER_TYPES.LOGIN_SUCCESS, createNavigateTo('/' + window.location.search)),
    takeEvery(USER_TYPES.LOGIN_2FA_REQUIRED, createNavigateTo('/2fa')),
    takeEvery(USER_TYPES.LOGOUT_SUCCESS, createNavigateTo('/')),
    takeEvery(USER_TYPES.LOGOUT_REQUEST, logoutUser),
    takeEvery(USER_TYPES.GET_DATA_FAILURE, logoutUser),
  ]);
}

function* loginUser(action) {
  const { username, password, remember = true } = action.payload;

  try {
    const user = yield call(login, username, password, remember);

    if (user.two_factor) {
      yield put(USER_ACTIONS.login2faRequired());
      return;
    }

    yield put(USER_ACTIONS.loginSuccess(user));
    yield put(USER_ACTIONS.getDataRequest());
  } catch (e) {
    yield put(USER_ACTIONS.loginFailure(e));
  }
}

function* logoutUser(action) {
  try {
    yield call(logout);
    yield put(USER_ACTIONS.logoutSuccess());
  } catch (e) {
    yield put(USER_ACTIONS.logoutFailure(e));
  }
}

function* getUserDetails() {
  try {
    const user = yield call(getUserData);
    yield put(USER_ACTIONS.getDataSuccess(user));
  } catch (e) {
    yield put(USER_ACTIONS.getDataFailure(e));
  }
}

export function* retrieveUserFromSession() {
  try {
    const user = yield call(getUserData);
    yield put(USER_ACTIONS.getDataSuccess(user));
  } catch (e) {
    yield put(USER_ACTIONS.loadLocalstorageFailure(e));
  }
}

export function* getCsrfToken() {
  try {
    yield call(fetchCsrfToken);
    yield put(USER_ACTIONS.getCsrfTokenSuccess());
  } catch (e) {
    yield put(USER_ACTIONS.getCsrfTokenFailure(e));
  }
}
